import React, { useState, useEffect } from "react";
import Preloader from "./components/Pre";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css"; 
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Education from "./components/Education/Education";
import Experience from "./components/Exoerience/Experience";
import NavBar from "./components/NavBar";
import CustomCursor from "./components/CustomCursor";
import RouteTransition from "./components/RouteTransition";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    // Simulate loading time - loader displays during this period
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 2500); // Increased to 2.5 seconds for full loader display

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <CustomCursor />
      <RouteTransition />
      <Preloader load={load} />
      {/* Content only visible when loader finishes */}
      <div className="App" style={{visibility: load ? 'hidden' : 'visible'}} id={load ? "no-scroll" : "scroll"}>
        <NavBar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/education" element={<Education />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
